import { render, staticRenderFns } from "./open-book.vue?vue&type=template&id=0f52918c&scoped=true&"
import script from "./open-book.vue?vue&type=script&lang=js&"
export * from "./open-book.vue?vue&type=script&lang=js&"
import style0 from "./open-book.vue?vue&type=style&index=0&id=0f52918c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f52918c",
  null
  
)

export default component.exports